import Vue from 'vue'
import VueRouter from 'vue-router'

import MainPage from '../components/MainPage/index';  // rename this file.
import ErrorPage from '../components/ErrorPage';
import CommunicaionCreator from '../components/Communication/Creator';
import CommunicaionManagement from '../components/Communication/Management';
import CommunicationUpdate from '../components/Communication/Update';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'MainPage',
    component: MainPage
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage
  },
  {
    path:"/communication/create",
    name:"CommunicaionCreator",
    component:CommunicaionCreator,
  },
  {
    path:"/communication/edit",
    name:"CommunicaionEditor",
    component:CommunicaionCreator,
    beforeEnter(to, from, next){
      if(to.params && to.params.communicationId){
        next();
      }else{
        next({name:"CommunicaionManagement"});
      }
    }
  },
  {
    path: '/communication/manage',
    name: 'CommunicaionManagement',
    component: CommunicaionManagement
  },
  {
    path: '/communication/update',
    name:"CommunicationUpdate",
    component: CommunicationUpdate,
    beforeEnter(to, from, next){
      if(to.params && to.params.communicationId){
        next();
      }else if(from.name != null){
        next({name:from.name});
      }else{
        next({name:"CommunicaionManagement"});
      }
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
